import React, { useState } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Button, 
  Box, 
  IconButton, 
  Menu, 
  MenuItem,
  useMediaQuery,
  useTheme,
  Slide
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import useScrollPosition from '../../hooks/useScrollPosition';

const Header = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();
  const isTouchDevice = useMediaQuery('(hover: none)');
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { scrollDirection } = useScrollPosition();
  const location = useLocation();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    { icon: <HomeIcon />, path: '/' },
    { text: 'About', path: '/about' },
    { text: 'Admissions', path: '/admissions' },
    { text: 'Academics', path: '/academics' },
    { text: 'Homeschool', path: '/homeschool' },
    { text: 'Homework Support', path: '/homework-support' },
    { text: 'Resources', path: '/resources' }
  ];

  const headerContent = (
    <AppBar 
      position={isTouchDevice ? 'static' : 'fixed'} 
      sx={{ 
        transition: 'transform 0.3s ease-in-out', 
        bgcolor: 'primary.dark',
        zIndex: theme.zIndex.appBar,
        ...(isTouchDevice && {
          position: 'static',
          boxShadow: 1,
          zIndex: theme.zIndex.appBar
        })
      }}
    >
      <Toolbar>
        <RouterLink
          to="/"
          style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/MacGillis Global Academy-05.png`}
            alt="MGA Logo"
            style={{ height: '40px' }}
          />
        </RouterLink>
        <Box sx={{ flexGrow: 1 }} />
        
        {isMobile ? (
          <>
            <IconButton
              size="large"
              edge="end"
              color="inherit"
              aria-label="menu"
              onClick={handleMenu}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {menuItems.map((item) => (
                <MenuItem
                  key={item.text || 'home'}
                  component={RouterLink}
                  to={item.path}
                  onClick={handleClose}
                >
                  {item.icon || item.text}
                </MenuItem>
              ))}
            </Menu>
          </>
        ) : (
          <Box>
            {menuItems.map((item) => (
              <Button
                key={item.text || 'home'}
                color="inherit"
                component={RouterLink}
                to={item.path}
                sx={{
                  mx: 0.5,
                  minWidth: item.icon ? '40px' : 'auto',
                  '&:hover': {
                    backgroundColor: 'primary.dark',
                  },
                  ...(location.pathname === item.path && {
                    borderBottom: '2px solid white',
                    borderRadius: 0,
                    '&:hover': {
                      backgroundColor: 'transparent',
                    }
                  })
                }}
              >
                {item.icon || item.text}
              </Button>
            ))}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );

  return isTouchDevice ? headerContent : (
    <Slide appear={false} direction="down" in={scrollDirection === 'up'}>
      {headerContent}
    </Slide>
  );
};

export default Header; 